import {inject, Injectable} from '@angular/core';
import {PlaceTwitchUserContext, Pixel} from '@/app/core/models/p-place/pixel';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PixelService {

	private http = inject(HttpClient);

	private readonly SERVICE_URI = `${environment.backendUrl}/pixels`;

	consumePixels(pixels: Pixel[]): Observable<PlaceTwitchUserContext> {
		return this.http.post<PlaceTwitchUserContext>(`${this.SERVICE_URI}/consume`, pixels);
	}

	getPlaceUserContext() : Observable<PlaceTwitchUserContext> {
		console.log('Getting place user context');
		return this.http.get<PlaceTwitchUserContext>(`${this.SERVICE_URI}/context`);
	}

}
